import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import store from "./store.js";
import axios from "axios";
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";

Vue.config.productionTip = false;

// Automatic Global Registration
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
const requireComponent = require.context("./components", false, /Base[A-Z]\w+\.(vue|js)$/);
requireComponent.keys().forEach((fileName) => {
	const componentConfig = requireComponent(fileName);
	const componentName = upperFirst(camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1")));

	Vue.component(componentName, componentConfig.default || componentConfig);
});

// Socket.io -- Extremely Buggy
const socket = io(process.env.VUE_APP_BASE_URL);
Vue.use(VueSocketIOExt, socket, { store });

// Import the Auth0 configuration
const authConfig = {
	domain: process.env.VUE_APP_AUTH_CONFIG_DOMAIN,
	clientId: process.env.VUE_APP_AUTH_CONFIG_CLIENTID,
	audience: process.env.VUE_APP_AUTH_CONFIG_AUDIENCE
};

// Import the plugin here
import { Auth0Plugin } from "@/auth";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
	domain: authConfig.domain,
	clientId: authConfig.clientId,
	audience: authConfig.audience,
	onRedirectCallback: (appState, authInstance) => {
		authInstance.getTokenSilently().then((authToken) => {
			// Send the JWT token to the backend
			axios
				.get(process.env.VUE_APP_BASE_URL + "/api/thisUser", {
					headers: {
						Authorization: `Bearer ${authToken}`
					}
				})
				.then((res) => {
					// Send the user back to their original URL request, or default to "/home"
					store.dispatch("login", res.data).then(() => {
						router.push(appState && appState.targetUrl ? appState.targetUrl : "/home");
					});
				});
		});
	}
});

new Vue({
	router,
	store,
	created() {
		// Automatic login using localstorage
		// https://www.vuemastery.com/courses/token-based-authentication/automatic-login
		if (localStorage.getItem("savedUserData")) {
			this.$store.commit("SET_SESSION_USER_DATA", JSON.parse(localStorage.getItem("savedUserData")));
		}

		// Local Storage Security Feature, https://www.vuemastery.com/courses/token-based-authentication/automatic-login
		axios.interceptors.response.use(
			(response) => response,
			(error) => {
				if (error.response.status.toString().substring(0, 1) === "4") {
					this.$store.dispatch("logout");
				}
				return Promise.reject(error);
			}
		);
	},
	render: (h) => h(App)
}).$mount("#app");
